import {useCallback} from 'react';
import {ApiResponse} from '@legit.health/backend-client';
import {DiagnosticReportApiResponse} from '@legit.health/ui';
import {useQueryClient} from '@tanstack/react-query';
import {getQueryKey} from './useGetDiagnosticReport';

export default function useSetDiagnosticReportQueryData() {
  const queryClient = useQueryClient();

  return useCallback(
    function (diagnosticReport: DiagnosticReportApiResponse) {
      queryClient.setQueryData<ApiResponse<DiagnosticReportApiResponse> | null>(
        getQueryKey(diagnosticReport.id),
        function () {
          return {
            isSuccessfull: true,
            error: null,
            status: 200,
            data: diagnosticReport
          };
        }
      );
    },
    [queryClient]
  );
}
